module.exports = __webpack_public_path__ + "static/media/eye.bde1ea59.svg";